import { themedUseStyletron } from '../../theme/customTheme'
import { styled } from "baseui";
import { ObjectAvatar } from './ObjectAvatar/ObjectAvatar';
import { LabelMedium, ParagraphXSmall } from 'baseui/typography';
import { useMemo } from 'react';
import { useObjectAlarms } from '../../hooks/useObjectAlarms';
import { getAlarmClassStyle } from '../../features/Alarm/alarmClassStyles';

export type ObjectHeaderProps = {
    name: string,
    description: string,
    PIS?: string,
    errSum?: boolean,
    isMan?: boolean,
    isOn?: boolean,
    objectId?: string,
    icon?: any,
    nameOverride?: string,
    resourceGroupId?: string,
    onColorOverride?: string | undefined,
    includeAlarmsFromChildren?: boolean,
}
export const ObjectHeader = ({ name, description, PIS, errSum, isMan, isOn, objectId, icon, nameOverride, resourceGroupId, onColorOverride, includeAlarmsFromChildren }: ObjectHeaderProps) => {
    const [css, theme] = themedUseStyletron();

    const { items: data, error, isLoading } = useObjectAlarms(objectId ?? '', resourceGroupId ?? '', includeAlarmsFromChildren)
    const first = useMemo(() => {
        return data?.slice()[0]
    }, [data]);
    const aclass = first ? getAlarmClassStyle(first?.alarmClass.name, first?.offTime !== undefined && first?.offTime !== null, theme) : undefined;

    const color = first ?
        aclass?.color :
        //  : isMan ? 
        isMan ?
            theme.appColors.aggregate.man : isOn ? (onColorOverride ?? theme.appColors.aggregate.on) : theme.colors.contentSecondary;

    const myname = nameOverride ? nameOverride : PIS ? PIS : name;
    return (
        <MainContainer>
            <AvatarContainer>
                <ObjectAvatar backgroundColor={color} icon={icon} name={description || name}></ObjectAvatar>
            </AvatarContainer>
            <TextContainer>
                <LabelMedium title={description} className={css({ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' })}>{description}</LabelMedium>
                <ParagraphXSmall title={myname} className={css({ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'  })} margin={0}>{myname}</ParagraphXSmall>
            </TextContainer>

        </MainContainer>
    )

}

// <Block display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' gridGap='10px' width={'100%'}>

const MainContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gridGap: $theme.sizing.scale300
}));

const TextContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'inline-block',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '80%'
}));

const AvatarContainer = styled<'div', {}>("div", ({ $theme }) => ({
    flexGrow: '0',
}));